import {
   createApiRequest,
   ApiResponse,
   getHeaderFromSessionStorage,
   Header,
} from "@/api"
import { API_URL, Endpoints } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"
import { CustomerForm } from "@/types/customer"
import { Facility } from "@/types/facility"

export interface CustomerResponse {
   id: string
   name: string
   state: string
   facilities: Facility[]
}

export async function requestCustomers(): Promise<
   ApiResponse<CustomerResponse[]>
> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.CUSTOMERS}`,
      HttpMethods.GET,
      null,
      getHeaderFromSessionStorage(Header.TENANT_ID)
   )
   return response
}

export async function requestCreateCustomer(
   customerData: CustomerForm
): Promise<ApiResponse<CustomerResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.CUSTOMERS}`,
      HttpMethods.POST,
      { ...customerData },
      getHeaderFromSessionStorage(Header.TENANT_ID)
   )
   return response
}

export async function requestUpdateCustomer(
   customerId: string,
   customerData: CustomerForm
): Promise<ApiResponse<CustomerResponse>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.CUSTOMERS}${customerId}/`,
      HttpMethods.PATCH,
      { ...customerData },
      getHeaderFromSessionStorage(Header.TENANT_ID)
   )
   return response
}

export async function requestDeleteCustomer(
   customerId: string
): Promise<ApiResponse<void>> {
   const response = await createApiRequest(
      `${API_URL}${Endpoints.CUSTOMERS}${customerId}`,
      HttpMethods.DELETE,
      null,
      getHeaderFromSessionStorage(Header.TENANT_ID)
   )
   return response
}
